import { render, staticRenderFns } from "./NewsViewVer2.vue?vue&type=template&id=1bc54248&scoped=true&"
import script from "./NewsViewVer2.vue?vue&type=script&lang=js&"
export * from "./NewsViewVer2.vue?vue&type=script&lang=js&"
import style0 from "./NewsViewVer2.vue?vue&type=style&index=0&id=1bc54248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc54248",
  null
  
)

export default component.exports